<template>
    <form
        :class="[
            'bli-form',
            { flex: !item && allowedFields['name'] && !allowedFields['geo'] },
        ]"
        novalidate
        @submit="emitSubmit"
    >
        <div v-if="allowedFields['geo']" class="form-field">
            <GeoSearchInput
                id="geo_name"
                ref="geoInput"
                v-model="form.geo.value"
                placeholder="Find location ..."
                :level="bucketList.type"
                @update:model-value="onGeoChange"
            />
            <FormError :errors="errors.geo" />
        </div>
        <div
            v-if="allowedFields['name'] && isGeoForbiddenOrSet"
            class="name-field form-field"
        >
            <label v-if="allowedFields['geo']" for="item-name">
                Pick a name for your location:
            </label>
            <label v-if="item && bucketList.type == 'custom'" for="item-name">
                Name:
            </label>
            <input
                id="item-name"
                ref="nameInput"
                v-model="form.name.value"
                type="text"
                placeholder="What would you like to tick?"
            />
            <FormError :errors="errors.name" />
        </div>
        <div v-if="!!item" class="form-field">
            <label for="image">Image:</label>
            <ImageUpload
                v-model="form.user_image_file.value"
                name="image"
                :img="form.user_image.value ? item.image_url : ''"
            />
            <Bttn
                v-if="form.user_image.value || form.user_image_file.value"
                type="button"
                class="slim outlined"
                style="margin-top: 5px"
                @click="clearImage"
            >
                Clear image
            </Bttn>
            <FormError :errors="errors.user_image_file" />
        </div>
        <div
            v-if="form.geo.value && item && !form.user_image.value"
            class="form-field"
        >
            <label for="image">Alternative image:</label>
            <WikiImagePicker
                v-model="form.wiki_image_url.value"
                :geo="form.geo.value"
            />
            <FormError :errors="errors.wiki_image_url" />
        </div>
        <div class="actions text-center">
            <Bttn
                v-if="isGeoForbiddenOrSet"
                id="submit-item"
                ref="submitButton"
                type="submit"
                class="slim"
            >
                {{ submitName }}
            </Bttn>
            <Bttn v-if="!!item" class="slim" @click="$emit('cancelled')">
                Cancel
            </Bttn>
        </div>
    </form>
</template>
<script>
import { useBucketListStore } from "js/stores/bucketListStore";
import GeoSearchInput from "js/components/forms/GeoSearchInput";
import BaseForm from "js/components/base/BaseForm.js";
import FormError from "js/components/forms/FormError";
import WikiImagePicker from "js/components/forms/WikiImagePicker";
import ImageUpload from "js/components/forms/ImageUpload";

export default {
    components: { GeoSearchInput, FormError, WikiImagePicker, ImageUpload },
    extends: BaseForm,
    props: {
        bucketList: {
            type: Object,
            required: true,
        },
        item: {
            type: Object,
            required: false,
            default: () => {},
        },
        errors: {
            type: Object,
            required: false,
            default: () => {},
        },
    },
    emits: ["cancelled"],
    data() {
        return {
            store: undefined,
            rules: {
                country: ["geo"],
                region: ["geo"],
                city: ["geo"],
                place: ["name", "geo"],
                custom: ["name"],
            },
            allowedFields: {},
            form: {
                geo: {
                    value: null,
                },
                name: {
                    value: null,
                },
                wiki_image_url: {
                    value: null,
                },
                user_image_file: {
                    value: null,
                },
                user_image: {
                    value: null,
                },
            },
            submitName: "Add",
        };
    },
    computed: {
        isGeoForbiddenOrSet() {
            return !this.allowedFields["geo"] || this.form.geo.value !== null;
        },
    },
    mounted() {
        this.store = useBucketListStore();
        this.rules[this.bucketList.type].forEach((key) => {
            this.allowedFields[key] = true;
        });
        if (this.item) {
            this.submitName = "Save";
        }
    },
    methods: {
        updateName() {
            if (this.bucketList.type === "place" && !this.item?.id) {
                this.form.name.value = this.form.geo.value?.name;
            }
        },
        onGeoChange(geo) {
            this.updateName();
            if (geo) {
                this.focusAfterGeoPick();
            }
        },
        focusAfterGeoPick() {
            this.$nextTick(() => {
                const nameInput = this.$refs.nameInput;
                if (nameInput) {
                    nameInput.focus();
                    nameInput.select();
                    return;
                }
                this.$refs.submitButton?.$el.focus();
            });
        },
        focusFirstField() {
            this.$nextTick(() => {
                if (this.allowedFields["geo"]) {
                    this.$refs.geoInput?.focus();
                    return;
                }
                this.$refs.nameInput?.focus();
            });
        },
        clearImage() {
            this.form.user_image.value = null;
            this.form.user_image.hasChanged = true;
            this.form.user_image_file.value = null;
        },
    },
};
</script>
